import { Typography } from '@mui/material';

import { useDeviceName } from '@/api/devices';
import { DeviceIcon } from '@/components/DeviceIcon';
import { LoadingIndicatorIcon } from '@/components/loaders/LoadingIndicatorIcon';
import { useSpotterContext } from '@/context/SpotterContext';
import { minorTextGrey } from '@/theme';

export const SpotterDetailsHeader = () => {
    const { spotterFamily } = useSpotterContext();
    const { data: device, isLoading } = useDeviceName();
    const { name, spotterId } = device ?? {};

    return (
        <Typography variant="h2" sx={{ display: 'flex', alignItems: 'center', m: 1, gap: 1 }}>
            <DeviceIcon spotterFamily={spotterFamily} hullType={device?.hullType} height="1em" />
            {name || spotterId}
            {name && name != spotterId && <span style={{ color: minorTextGrey }}> {spotterId}</span>}
            <LoadingIndicatorIcon isLoading={isLoading} />
        </Typography>
    );
};
